document.domain = /clinique.com/.test(document.domain) ? 'clinique.com' : 'elcdev.net';

(function ($) {
  Drupal.behaviors.taazLandingV1 = {
    attach: function (context, settings) {
      var productList = $('.taaz-products');
      var summary = $('.taaz-summary');
      var container = $('.taaz-landing');
      var iframe = $('#taazIframe');
      var productClass = 'product-tout';
      var lookName = '';
      var lookId = '';
      var skusLoaded = [];
      // // TEST
      // var testSkus = ['SKU13489','SKU11619'];
      // var loadBtn = $('<a/>')
      //    .addClass('button')
      //    .text("Load ")
      //    .click(function(){
      //        loadProducts({skuIds: testSkus});
      //        highlightProducts({skuIds: testSkus});
      //    });
      // container.append(loadBtn);
      // // END TEST
      var navLinks = $('.taaz-nav').find('a');

      // if hashchange isn't good enough... need to re-enable this
      /*    navLinks.click(function() {
        navLinks.removeClass('button');
        $(this).addClass('button');
        console.log($(this).attr('href'));  //pass this along to iframe URL
    });  */
      clearProducts = function () {
        productList.empty();
        productList.hide();
      };
      // summary isn't currently being used... leaving some of the summary fxns in though, because I'm sure it'll be back
      clearSummary = function () {
        summary.empty();
        summary.hide();
      };
      $(window).on('hashchange', function () {
        changeLooks();
      });
      // handle nav changes and iframe changes for selected look... triggers on load and on hashchange
      // setup info like Look Name and Look Id (what we pass to TAAZ) is derived from the taaz-nav
      (changeLooks = function () {
        var thisLink = $('.taaz-nav').find('[href=' + document.location.hash + ']');

        if (!thisLink.length) {
          document.location.hash = '#naturallypretty'; // either no hash, or not a valid look id... default to naturally pretty

          return false; // let hashchange bring us back
        }
        lookName = thisLink.text();
        lookId = document.location.hash.replace('#', '');
        navLinks.removeClass('selected-look');
        thisLink.addClass('selected-look');
        $('.taaz-nav').find('.section').hide();
        thisLink.closest('.section').show(); // turn on the parent .section of our look
        skusLoaded = [];
        clearProducts();
        // clearSummary();
        // update the iframe url for the new look
        var url = iframe.attr('src');

        url = url.replace(/#.*/, '');
        url += '#lookname=' + lookId;
        iframe.attr('src', url);
      })();
      // handle the add to bag click events for the individual product add to bags as well as the add all btn
      // (initAddToBags = function(){
      //    summary.on("click", ".add-to-bag", function(){
      //        var loadingParams = {
      //            target: this,
      //            "matchTarget": ["display", "height", "width"]
      //        };
      //        var loadingId = site.loading.show(loadingParams);
      //        $(document).one("addToCart.success addToCart.failure", function () {
      //          site.loading.hide(loadingId);
      //        });
      //        var ids = productList.find('.add-to-bag').map(function(){
      //            return $(this).attr('data-skubaseid');
      //        });
      //        addAllToBag({ skuIds:ids.toArray() });
      //    });
      // })();
      // Quickview popover
      (initQuickshops = function () {
        productList.on('click', '.btn-quickview', function (e) {
        // most of this ported from customerServiceConsultantProfileRowV1
          e.preventDefault();
          $('#quickshop .close').trigger('click');
          var quickview_btn = e.target;
          var prodId = $(this).closest('.product').attr('data-productid');

          if (typeof prodId !== 'undefined') {
            var product = page_data['product-input-type'].products.filter(function (p) {
              return p !== null ? p.PRODUCT_ID === prodId : false;
            })[0];
          }
          var $qs = site.quickshop.render({ productData: product });
          var select_type = $('.shades', $qs).length === 0 ?
            $('.skin-type.hidden', $qs).length === 0 ? 'skin_type' : 'size'
            : 'shade';

          $('.select_type', $qs).html($('span[data-localtrans="' + select_type + '"]', $qs).html()).removeClass('hidden');
          $qs.css('display', 'block').find('.close').hide();

          // wait for review to come in so content stays centered...
          $(document).on('qs.review', function (e) {
            generic.overlay.launch({
              content: $qs,
              center: true,
              includeBackground: true,
              hideOnClickOutside: true,
              includeCloseLink: true
            });
          });
        });
      })();

      // all the products are loaded and hidden... we just show the one(s) for the given step though
      // taaz calls this from within the iframe to tell us which products to display
      highlightProducts = function (args) {
        var skuIds = args.skuIds;
        // get all the product elements in one-shot... helps to make sure we are loading everything
        var selector = $.map(skuIds, function (el) {
          return '.product[data-skuid=' + el + ']';
        }).join(',');
        var el = $(selector);

        // if we got them all, we can show them now
        if (el.length == skuIds.length) {
          handleHighlightStyling({ selected: el });
        } else {
          // if not, we wait on taazlist.loaded events (fired by loadProducts) until they are all ready
          // primary issue is that sometimes highlightProducts is called before loadProducts has completed... taaz calls them back-to-back on the first step
          $(document).on('taazList.loaded', function () {
            var el = $(selector);

            if (el.length == skuIds.length) {
              handleHighlightStyling({ selected: el });
              $(document).unbind('taazList.loaded'); // we're done waiting
            }
          });
        }
      };

      handleHighlightStyling = function (args) {
        var selected = args.selected;
        var prodNodes = selected.parent();

        productList.find('.' + productClass).removeClass('selected first last middle');
        prodNodes.addClass('selected');
        // primarily this is to make sure the CSS for borders on multiple items turn out right
        if (selected.length > 1) {
          prodNodes.filter(':first').addClass('first');
          prodNodes.filter(':last').addClass('last');
          prodNodes.filter(':not(:last, :first)').addClass('middle');
        }
      };

      addAllToBag = function (args) {
        var skuIds = args.skuIds;
        var skuBaseIds = $.map(skuIds, function (el) {
          return el.replace(/SKU/, '');
        });
        var success = args.onSuccess || args.callback || {};
        var failure = args.onFailure || args.callback || {};

        site.addToCart({ skuBaseId: skuBaseIds });
        $(document).one('addToCart.success', function () {
          if (typeof success === 'function') {
            success();
          }
        });
        $(document).one('addToCart.failure', function () {
          if (typeof failure === 'function') {
            failure();
          }
        });
      };

      // gather up the data for taaz_summary_embed (appears in upper right) and then insert it
      genSummary = function (args) {
        clearSummary();
        var data = {
          totalProducts: args.totalProducts,
          lookName: lookName,
          totalCostFormatted: args.totalCost.toFixed(2),
          image: '/media/images/taaz/' + lookId + '.jpg'
        };

        Drupal.cl.template.get({
          path: 'taaz_summary_embed',
          object: data,
          callback: function (html) {
            summary.append($(html));
            summary.show();
          }
        });
      };

      // do an ajax call to Drupal get all the skus taaz needs (they send over one req for the look). each sku populates the taaz_product_embed inline template on the page
      // we need lots of extra data now that this is QS instead of Add to Bag. Per Matty, this is better to have Drupal load up on the backend for akamai caching purposes
      loadProducts = function (args) {
        var skuIds = args.skuIds;

        // if we already loaded these, skip
        if ($(skuIds).not(skusLoaded).length == 0 && $(skusLoaded).not(skuIds).length == 0) {
          return false;
        }
        var loadingParams = {
          target: productList
        };
        var loadingId = site.loading.show(loadingParams);
        var options = {};
        var productLocator = encodeURIComponent(skuIds.join(','));
        // defined in clinique_common_menu for grabbing sku data from Drupal
        var url = '/skuData/' + productLocator;

        options.success = function (data, textStatus, response) {
          site.loading.hide(loadingId);
          // save skuIds so we don't try to reload everything
          skusLoaded = skuIds;
          clearProducts();
          // values to save for the summary
          var total = 0;
          var count = data.skus.length;

          // QS fxn borrowed from CS consultants expects page_data["product-input-type"]...let's use that
          page_data = page_data || {};
          page_data['product-input-type'] = {};
          page_data['product-input-type'].products = [];
          // render each product row
          $(data.skus).each(function () {
            Drupal.cl.template.get({
              path: 'taaz_product_embed',
              object: this,
              callback: function (html) {
                productList.append($(html));
                productList.show();
                $(document).trigger('taazList.loaded'); // let highlightProducts know it can try to load now if it's waiting
              }
            });
            // the backend PG fxn we need gives a sku with a child product... we want the opposite
            var product = this.product;

            delete this.product;
            product.skus = [];
            product.skus.push(this);
            page_data['product-input-type'].products.push(product);
            // also store the sku in $(document).data ... site.quickshop.render expects this
            $(document).data(this.SKU_ID, this);
            total += this.PRICE;
          });
          // handle the Add All to Bag summary in the upper right
          // genSummary({
          //    totalCost: total,
          //    totalProducts: count,
          //    lookName: lookName
          // });
        };
        $.ajax(url, options);
      };
    }
  };
})(jQuery);
